import { Context } from '../..';
import { NotificationPriority, NotificationType } from '../../../notifications/notifications.models';
import { JobsResponse } from '../../../models';
import { JobDescription, JobsSearchRequest } from '../../../models/jobs';
import * as base from '../base';

export async function getJobTitles(_: Context, requestBuilder: JobsSearchRequest) {
  const jobTitleParams = requestBuilder.jobProvider.map(value => `jobProvider=${value}`).join('&');
  const params = new URLSearchParams(Object.entries(requestBuilder));
  params.delete('jobProvider');

  const request: base.IRequest = { url: base.apiURL(`jobs?${params.toString()}&${jobTitleParams}`), authenticated: true };
  const response: base.IResponse<JobsResponse> = await base.request(request);

  return response.data;
}

export async function getJobTitle(context: Context, slug: string) {
  const request: base.IRequest = { url: base.apiURL(`jobs`, slug), authenticated: true };
  const response: base.IResponse<JobDescription> = await base.request(request);

  if (response.error) {
    context.actions.addNotification({
      type: NotificationType.Error,
      priority: NotificationPriority.Toast,
      title: 'Something went wrong',
      message: `Unfortunately we couldn't load the information for that role. Please try again later`,
      active: true,
      id: slug,
    });
  }

  return response.data;
}

